<template>
    <RatingSummarySection v-if="ratingSummaries" :ratingSummaries="ratingSummaries" commentType="site_review" hideDistribution />
    <SideScrollingCommentList commentType="site_review" />
</template>

<style>
.gmf-site-review-banner {
    clear: both;
    display: flex;
    gap: var(--gmf-p-4);
    max-width: 100%;
}

.gmf-site-review-banner .gmf-new-comments-slideshow-wrapper {
    height: unset;
}
.gmf-site-review-banner .gmf-comment-rating-summaries {
    margin: 0;
}

@media (max-width: 550px) {
    .gmf-site-review-banner {
    flex-direction: column;
    align-items: center;
    max-height: 100%;
    max-width: 100%;
    width: 100%;
    overflow: hidden;
    gap: var(--gmf-p-3);
    }
}
</style>

<script>
import SideScrollingCommentList from '@/widgets/SideScrollingCommentList';
import RatingSummarySection from '@/widgets/CommentSection/RatingSummarySection';
import callApi from '@/utils/callApi';

export default {
    name: 'SiteReviewBanner',
    components: {
        SideScrollingCommentList,
        RatingSummarySection,
    },
    data () {
        return {
            ratingSummaries: null,
        };
    },
    async mounted () {
        const res = await callApi('GET', `/v3/site-score`);
        const data = await res.json();
        this.ratingSummaries = {
            site_score: data,
        };
    },
};
</script>